import React, { ReactElement } from 'react';
import Head from 'next/head';

import { getLayout } from 'components/layouts/Sidebar';
import { withAuth } from 'lib/hocs/withAuth';
import { useAuth } from 'lib/providers/AuthProvider';
import { LOCALE_PAGES, fetchTranslationFiles } from 'lib/services/page';
import CompanyEventsListing from './CompanyEventsListing';
import SocietyEventsListing from './SocietyEventsListing';

const Campaigns = (): ReactElement => {
  const { isManager, isRecruiter } = useAuth();

  return (
    <>
      <Head>
        <title>Campaigns | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      {isManager ? <SocietyEventsListing /> : null}
      {isRecruiter ? <CompanyEventsListing /> : null}
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.COMMON],
      })),
    },
  };
}

const CampaignsWrapper = withAuth(Campaigns);

// @ts-ignore
CampaignsWrapper.getLayout = getLayout;

export default CampaignsWrapper;
